import { useCallback } from 'react';
import { removeFromLocalStorage } from '@/local-storage/utils';
import SentryService from '@/utils/sentry';
import { useMsalAccount } from './use-msal-account';

export const useMsalLogout = (redirectTo: string = '/') => {
  const { msalInstance } = useMsalAccount();

  const logout = useCallback(async () => {
    removeFromLocalStorage('accepted-terms');
    removeFromLocalStorage('usage-analytics-enabled');

    // Clear Sentry user context on logout
    SentryService.clearUserContext();

    await msalInstance.logout({
      postLogoutRedirectUri: redirectTo,
    });
  }, [msalInstance, redirectTo]);

  return logout;
};
